document.addEventListener('DOMContentLoaded', () => {

  /* ==================================================
     WSPÓLNA FUNKCJA: OTWARCIE I ODŚWIEŻENIE CART DRAWER
  =================================================== */
  async function openCartDrawer() {
    const res = await fetch(
      `${Shopify.routes.root}?sections=cart-drawer,cart-icon-bubble`
    );
    const sections = await res.json();

    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    // fix empty state
    cartDrawer.classList.remove('is-empty');
    cartDrawer
      .querySelector('cart-drawer-items')
      ?.classList.remove('is-empty');

    cartDrawer.renderContents({ sections });
  }

  /* ==================================================
     STANDARD ADD TO CART – FORMULARZE
  =================================================== */
  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!form.matches('form[action="/cart/add"]')) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' }
      });

      await openCartDrawer();
    } catch (err) {
      console.error('Add to cart (form) error:', err);
    }
  });

  /* ==================================================
     UPSELL ADD TO CART – PRZYCISK
  =================================================== */
  document.addEventListener('click', async (event) => {
    const btn = event.target.closest('.upsell-add-btn');
    if (!btn) return;

    // zapobiegamy domyślnym listenerom motywu (Dawn)
    event.preventDefault();
    event.stopPropagation();

    let items = [];

    // Dodajemy główny produkt tylko jeśli jest checkbox z data-main-product lub nie istnieje
    const mainCheckbox = document.querySelector('.upsell-checkbox[data-main-product]');
    if (!mainCheckbox || mainCheckbox.checked) {
      const mainVariant = document.querySelector('form[action="/cart/add"] [name="id"]')?.value;
      if (mainVariant) {
        items.push({ id: mainVariant, quantity: 1 });
      }
    }

    // Dodajemy wszystkie zaznaczone upselle
    document.querySelectorAll('.upsell-checkbox:checked').forEach(cb => {
      // Pomijamy główny produkt, jeśli checkbox z data-main-product
      if (!cb.dataset.mainProduct) {
        items.push({
          id: cb.dataset.variantId,
          quantity: 1
        });
      }
    });

    if (!items.length) return;

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items })
      });

      await openCartDrawer();
    } catch (err) {
      console.error('Upsell add error:', err);
    }
  }, true); // capture mode, uruchamia listener przed innymi
});
